"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const mobx_react_lite_1 = require("mobx-react-lite");
const context_1 = require("../../../context");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const CarouselViewCount_1 = tslib_1.__importDefault(require("../../../ui-lib/Carousel/CarouselViewCount"));
const ViewCount = (0, mobx_react_lite_1.observer)(({ classes, publicKey }) => {
    const ctx = (0, react_1.useContext)(context_1.MultistreamContext);
    const playerCtx = (0, react_1.useContext)(context_1.PlayerUiContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)(ctx != null, "<ViewCount/>");
    const getKey = () => {
        if (publicKey != null) {
            return publicKey;
        }
        if ((playerCtx === null || playerCtx === void 0 ? void 0 : playerCtx.multistreamPlayerPublicKey) != null) {
            return playerCtx.multistreamPlayerPublicKey;
        }
        return null;
    };
    const viewCount = () => {
        var _a;
        const key = getKey();
        if (typeof key === "string" && ctx.streams[key].viewCount != null) {
            return (_a = ctx.streams[key].viewCount) !== null && _a !== void 0 ? _a : "unavailable";
        }
        return "unavailable";
    };
    return react_1.default.createElement(CarouselViewCount_1.default, { classes: classes, viewCount: viewCount() });
});
/**
 *
 * @visibleName View Count
 */
// eslint-disable-next-line react/function-component-definition
const ViewCountWithErrorBoundary = ({ classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(CarouselViewCount_1.default, { classes: classes, viewCount: "unavailable", ...props }) },
        react_1.default.createElement(ViewCount, { classes: classes, ...props })));
};
exports.default = ViewCountWithErrorBoundary;
//# sourceMappingURL=ViewCount.js.map